exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".language-selector {\n  align-items: center;\n  column-gap: 1rem;\n  display: flex; }\n  @media (min-width: 60.0625em) {\n    .language-selector {\n      justify-content: center; } }\n", ""])